/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';

import template from './ad-unit-list-page.component.html';
import {AdminListColumn, AdminResourceListPageBase} from '../common/controller/admin-resource-list-page-base';
import {columnFinder} from '../common/controller/resource-list-utils';
import {AdUnitBulkActionService} from './ad-unit-bulk-action.service';
import {getCountryName} from '../common/directives/country-select/countries';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';

@Component({
  standalone: false,
  selector: 'adn-ad-unit-list-page',
  template
})
export class AdUnitListPageComponent extends AdminResourceListPageBase {
  readonly itemStateName = 'app.inv.ad-units.ad-unit';
  readonly siteItemStateName = 'app.inv.sites.site';

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any,
    private readonly adUnitBulkActionService: AdUnitBulkActionService
  ) {
    super(LocalNetworkProfile);
  }

  get columns(): AdminListColumn[] {
    return this.normalizeColumns(this.list?.auFields || []);
  }

  hasColumn(param: string): boolean {
    return columnFinder(this.list, 'auFields', param);
  }

  copyTagId(tagId: string): void {
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(tagId);
    }
  }

  countryName(adUnit: any): string {
    return getCountryName(adUnit?.country);
  }

  protected afterListInit(): void {
    if (!this.list) {
      return;
    }
    if (!this.list.joinFilterBy) {
      this.list.joinFilterBy = 'Site';
    }
    if (!this.list.bulkAction) {
      this.list.bulkAction = this.adUnitBulkActionService.createBulkAction(this.list);
    }
  }
}
